import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Toaster } from "./toaster.interface";
import { ToasterService } from "./toaster.service";

@Component({
    selector: "app-toast-config",
    templateUrl: "toaster-config.component.html",
    styles: [],
    standalone: false
})
export class ToasterConfigComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  toasts: Toaster[] = [];

  constructor(private toaster: ToasterService) {}

  ngOnInit() {
    this.toaster.clear$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.toasts = [];
      });

    // prevent leak: duplicated toasts on destroy/ remount
    this.toaster.toast$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((toast) => {
        this.toasts = [toast, ...this.toasts];
        setTimeout(() => this.toasts.pop(), toast.delay || 6000);
      });
  }

  remove(index: number) {
    this.toasts = this.toasts.filter((v, i) => i !== index);
  }
}
